/**
 * Design tokens — Breakpoints
 *
 * Viewport width thresholds (px). Mirrored in web/src/styles/tokens.css as
 * --bp-*. Because components style via inline `style={}` objects (no CSS
 * classes, no @media), these values are consumed in JS through the
 * useMediaQuery hook (web/src/lib/useMediaQuery.ts) rather than in a stylesheet.
 *
 * The shell treats < lg (1024px) as "compact": the sidebar collapses to an
 * off-canvas drawer opened from a top-bar menu button (see shell/AppLayout.tsx).
 */

export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export type Breakpoint = keyof typeof breakpoints;
